import { HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input("media_query") mobileQueryMax: boolean;
  @Input() showleft_menu: boolean;
  @Output('toggle') navToggle = new EventEmitter();
  @Output() sayHi = new EventEmitter<String>();
  @Output() login_success = new EventEmitter<boolean>();
  @Input() Username: string;

  baseurl: string;
  demoMailNoti = 50
  demoNoti = 9
  notiCount: number = null;
  projectSaleItem: any = null;

  projectSaleData: any[] = [];
  private eventSource: EventSource | null = null;

  _EmpRole: string;

  constructor(private router: Router) {
    this.baseurl = environment.base_api;
   }



  ngOnInit(): void {
    this._EmpRole = localStorage.getItem("EmpRoleCode");
    
    // this.getProjectSalePlanningData();
  }

  onClickNavToggle() {
    this.navToggle.emit();
  }

  btnClick_LogOut() {
    localStorage.clear();
    this.router.navigate(['/']);
    this.login_success.emit(false)
  }

  btnTimeSheet() {
    this.router.navigate(['/time-sheet']);
  }

  btnProfile() {
    this.router.navigate(['/user-profile']);
  }

  onNotifClick(item: any){
    console.log("onNotif = ", item);
    //  this.getProjectSalePlanningData();

    this.notiCount = null;
    this.projectSaleItem = item;
    // console.log('ProjectSaleCode', this.projectSaleItem.ProjectSaleCode);

    $('#ModalNotif').modal();

  }

  getProjectSalePlanningData(){
    console.log("getProjectSalePlanningData()..", localStorage.EmpCode);

    // let httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'application/json',
    //     'Authorization': `Bearer ${localStorage.refreshToken}`
    //   })
    // };
    let empCode: string = localStorage.EmpCode;
    // let empCode: string = "DP0201";

    const url = this.baseurl + `Notification/events?empCode=${empCode}`;
    console.log("url =" , url)
    this.eventSource = new EventSource(url);

    this.eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        this.projectSaleData = data;
        if(data.length > 0){
          this.notiCount = data.length;
        }else{
          this.notiCount = null;
        }
        
        // console.log('Received SSE data:', data);
      } catch (error) {
        console.error('Error parsing SSE data:', error);
        this.notiCount = null;
      }
    };

    this.eventSource.onerror = (error) => {
      console.error('SSE connection error:', error);
      this.eventSource?.close();
    };



  }
}
